export default __webpack_public_path__ + "img/639d4590e546c59166668dd40e850d76.svg";